<template>
    <div>
        <Banner :banners="banners" show-overlay> </Banner>
        <Breadcrumb></Breadcrumb>
        <div class="info-wrapper default">
            <h2 class="title text-center">川流城事</h2>
            <p class="text-sm">
                「一個國家要有好的河川才會偉大」，臺中的七大河川，在歷任市長的努力之下，展現了城市的新風貌，也提供民眾更好的水安全、水資源、水環境。認識臺中，一同走訪臺中的七大河川!
            </p>
            <ul>
                <li v-for="river in nearbyRiverList" :key="river.id">
                    <a href="" @click.prevent="goDetail(river.id)">
                        <div class="list-card">
                            <div class="img-wrapper">
                                <vue-load-image>
                                    <img
                                        slot="image"
                                        :src="
                                            `${apiPhotoUrl}/ori/${river.photoId}`
                                        "
                                        :alt="river.name"
                                    />
                                    <img
                                        slot="preloader"
                                        src="@/assets/image-loader.gif" class="w-100"
                                    />
                                    <img
                                        slot="error"
                                        class="border d-block bg-white"
                                        src=""
                                        alt="not found"
                                    />
                                </vue-load-image>
                            </div>
                            <div class="card-body">
                                <div class="title" v-text="river.name">
                                    柳川
                                </div>
                                <div class="distance" v-show="river.distance">
                                    <img
                                        src="@/assets/self_ic_map.png"
                                        alt="距離"
                                    />{{ river.distance }}m
                                </div>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
/* eslint-disable global-require */
import { mapGetters } from 'vuex';
import Banner from '@/components/shared/Banner';
import Breadcrumb from '@/components/Breadcrumb';
import coreMixin from '@/js/mixin/coreMixin';

export default {
    data() {
        return {
            banners: [
                {
                    linkUrl: require('@/assets/banner_guide.jpg'),
                },
            ],
        };
    },
    computed: {
        ...mapGetters('dataList', ['nearbyRiverList']),
    },
    components: {
        Banner,
        Breadcrumb,
    },
    methods: {
        goDetail(id) {
            this.$router.push(`${this.$route.path}/${id}`);
        },
    },
    mixins: [coreMixin],
};
</script>

<style></style>
